// Preload components for faster transitions
const preloadComponents = {
  // Student views
  studentFeed: () => {
    import('../PostCreationComponents');
    import('../PostComponents');
  },
  studentSummary: () => {
    // Already eagerly loaded (CompetencySummary, SkillAveragesGrid)
  },
  studentTranscript: () => {
    import('../TranscriptProjectsSection');
    import('../ClassManagementComponents');
    import('../TimeLoggingComponents');
    import('../CertificateComponents');
  },
  studentTimeLogging: () => {
    import('../TimeLoggingComponents');
  },
  studentBookLogging: () => {
    import('../BookLoggingComponents');
  },
  studentCertificates: () => {
    import('../CertificateComponents');
  },
  studentMentors: () => {
    import('../MentorComponents');
  },
  studentClassProposals: () => {
    import('../ClassManagementComponents');
  },
  studentProjects: () => {
    import('../ProjectManagementComponents');
  },
  // Teacher views
  teacherMatrix: () => {
    import('../StudentScoreMatrix');
  },
  teacherStudentFeedback: () => {
    import('../PostComponents');
  },
  teacherTranscripts: () => {
    import('../TranscriptProjectsSection');
    import('../ClassManagementComponents');
    import('../TimeLoggingComponents');
    import('../CertificateComponents');
    import('../GraduationRequirementsComponents');
  },
  teacherActivityLogging: () => {
    import('../TimeLoggingComponents');
  },
  teacherCertificatesView: () => {
    import('../CertificateComponents');
  },
  teacherClassManagement: () => {
    import('../ClassManagementComponents');
  },
  teacherGraduationRequirements: () => {
    import('../GraduationRequirementsComponents');
  },
  teacherMentorManagement: () => {
    import('../MentorComponents');
  },
  teacherStudentProjects: () => {
    import('../ProjectManagementComponents');
  },
  // PDF is loaded on-demand only
  pdf: () => {
    import('../TranscriptPDF');
    import('@react-pdf/renderer');
  }
};

export default preloadComponents;


